import { create } from "zustand";
import { channelList } from "../constants/channel-list";

const useAudioPlayerStore = create((set) => ({
  isPlaying: true,
  setIsPlaying: (isPlaying) => set({ isPlaying }),

  currentChannel: channelList?.[0],
  setCurrentChannel: (currentChannel) => set({ currentChannel }),

  tracks: channelList?.[0]?.channelTracks,
  setTracks: (tracks) => set({ tracks }),

  currentTrack: null,
  setCurrentTrack: (currentTrack) => set({ currentTrack }),

  isBuffering: true,
  setIsBuffering: (isBuffering) => set({ isBuffering }),
}));

export default useAudioPlayerStore;
